module.exports = __webpack_public_path__ + "static/media/download_arrow.5d156a7f.svg";